import React from 'react'
import Paper from '@material-ui/core/Paper'
import style from './wrapper.style'

const Wrapper = ({ classes, children, shadow, style, className }) => {
  return (
    <Paper
      style={style}
      elevation={shadow}
      classes={{ root: className, rounded: classes.box }}
    >
      {children}
    </Paper>
  )
}

const Header = ({ children }) => {
  if (children) {
    return <header>{children}</header>
  }
}

const Body = ({ children }) => {
  if (children) {
    return
  }
}

export default style(Wrapper)
